import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useController } from "react-hook-form";
import { getSharedLabels } from "../Api/content";
import { useLocale } from "../i18n/localeContext";

export default function ReactSelect({
  rules = {},
  control,
  lista = [],
  name,
  disabled = false,
  height = 34,
  placeholder = "Seleccione",
}) {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      background: "#fcfafa",
      // Overwrittes the different states of border
      borderColor: "#c1c1c1",
      // Removes weird border around container
      boxShadow: state.isFocused ? null : null,
      borderRadius: 10,
      fontFamily: "circularBook",
      fontSize: "14px",
      height: height,
      minHeight: height,
    }),
    menu: (base) => ({
      ...base,
      fontFamily: "circularBook",
      zIndex: 9999,
    }),
  };

  const {
    field: { onChange, value, ref },
  } = useController({
    name,
    control,
    rules: rules,
  });

  const { locale } = useLocale();
  const [sharedLabels, setSharedLabels] = useState(null);
  useEffect(() => {
    let cancel = false;
    getSharedLabels(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) setSharedLabels(data);
      })
      .catch(() => { if (!cancel) setSharedLabels(null) });
    return () => { cancel = true };
  }, [locale])

  useEffect(() => {
    const newFirstElement = { label: sharedLabels?.select_option || "Seleccione", value: undefined };
    if (lista.length > 0) {
      if (lista[0].value !== undefined) lista.unshift(newFirstElement);
    }
  }, [lista]);

  return (
    <Select
      isDisabled={disabled}
      styles={customStyles}
      inputRef={ref}
      classNamePrefix="addl-class"
      placeholder={sharedLabels?.select_option || "Seleccione"}
      options={lista}
      noOptionsMessage={() => sharedLabels?.withoutresult || "Sin resultados"}
      value={lista.find((c) => c.value === value) || ""}
      onChange={(val) => onChange(val.value)}
    />
  );
}
